// extracted by mini-css-extract-plugin
export var promotionLink = "_ux-0";